const graphic = "_arag18h8d2a";
const button = "_arabyp2j7t";

export { button, graphic };
import "./modal.retry.style.linaria.module.css";
//# sourceMappingURL=modal.retry.style.js.map
